export default __webpack_public_path__ + "static/media/thirdImg.837ee940.gif";